import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BigStoryCardCurve from "../big-story-card-curve/index";
import SmallStoryCardCurve from "../small-story-card-curve/index";

import styles from "./styles.m.css";

const ElectionStoryTwoCollectionStoryStack = ({
  bigStory,
  mobileStoryCount,
  stories,
  className,
  verticalimg = true,
  bigimage,
  bigStoryHover = false,
  bighorizontalcard
}) => {
  if (stories.length < 1) {
    return null;
  }
  const [pageName, setPageName] = useState("home");

  useEffect(() => {
    const getpageName = global && global.location.pathname;
    const pageName = getpageName.split("/").pop();
    const getPFrom = pageName || "home";
    setPageName(getPFrom);
  }, []);
  return (
    <div className={`${styles["base"]} ${className}`}>
      <div className={styles["big-story-container"]}>
        <BigStoryCardCurve
          story={stories[0]}
          key={stories[0].id}
          className={`${styles["index-one"]}`}
          bigimage={bigimage}
          pFrom={`${pageName}-fourteen-story-collection`}
          bighorizontalcard={true}
          iconbottomright={true}
        />
      </div>
      <div className={styles["small-stories-grid"]}>
        {stories.slice(1).map((story, index) => (
          <SmallStoryCardCurve
            story={story}
            verticalimg={true} // Horizontal Image Left, Text Right for small cards
            className={styles["grid-item"]}
            key={story.id}
            pFrom={`${pageName}-fourteen-story-collection`}
            iconbottomright={true}
          />
        ))}
      </div>
    </div>
  );
};

ElectionStoryTwoCollectionStoryStack.propTypes = {
  bigStory: PropTypes.bool,
  verticalimg: PropTypes.bool,
  bigimage: PropTypes.bool,
  mobileStoryCount: PropTypes.number,
  stories: PropTypes.arrayOf(BigStoryCardCurve.propTypes.story),
  className: PropTypes.string,
  bigStoryHover: PropTypes.bool,
  bighorizontalcard: PropTypes.bool
};

export default ElectionStoryTwoCollectionStoryStack;
